import { lazy } from 'react';

export const SignInScreen = lazy(() =>
  import('../../features/auth/SignInScreen.js').then((module) => ({
    default: module.SignInScreen,
  }))
);
export const RegisterScreen = lazy(() =>
  import('../../features/auth/RegisterScreen.js').then((module) => ({
    default: module.RegisterScreen,
  }))
);
export const SignUpPendingScreen = lazy(() =>
  import('../../features/auth/SignUpPendingScreen.js').then((module) => ({
    default: module.SignUpPendingScreen,
  }))
);
export const ConfirmEmailScreen = lazy(() =>
  import('../../features/auth/ConfirmEmailScreen.js').then((module) => ({
    default: module.ConfirmEmailScreen,
  }))
);
export const OnboardingSetCredentialsScreen = lazy(() =>
  import('../../features/auth/OnboardingSetCredentialsScreen.js').then((module) => ({
    default: module.OnboardingSetCredentialsScreen,
  }))
);
export const ForgotPasswordScreen = lazy(() =>
  import('../../features/auth/ForgotPasswordScreen.js').then((module) => ({
    default: module.ForgotPasswordScreen,
  }))
);
export const ResetPasswordScreen = lazy(() =>
  import('../../features/auth/ResetPasswordScreen.js').then((module) => ({
    default: module.ResetPasswordScreen,
  }))
);
export const ShopScreen = lazy(() =>
  import('../../features/shop/ShopScreen.js').then((module) => ({
    default: module.ShopScreen,
  }))
);
export const ScannerPage = lazy(() =>
  import('../../features/shop/ScannerPage.js').then((module) => ({
    default: module.ScannerPage,
  }))
);
export const SelfScanScannerPage = lazy(() =>
  import('../../features/self-scan/components/SelfScanScannerPage.js').then((module) => ({
    default: module.SelfScanScannerPage,
  }))
);
export const PlatformScanPage = lazy(() =>
  import('../../features/shop/PlatformScanPage.js').then((module) => ({
    default: module.PlatformScanPage,
  }))
);
export const AccountShell = lazy(() =>
  import('../../features/account/AccountShell.js').then((module) => ({
    default: module.AccountShell,
  }))
);
export const AccountHomePage = lazy(() =>
  import('../../features/account/AccountHomePage.js').then((module) => ({
    default: module.AccountHomePage,
  }))
);
export const AccountDonationsPage = lazy(() =>
  import('../../features/account/AccountDonationsPage.js').then((module) => ({
    default: module.AccountDonationsPage,
  }))
);
export const AccountPaymentsPage = lazy(() =>
  import('../../features/account/AccountPaymentsPage.js').then((module) => ({
    default: module.AccountPaymentsPage,
  }))
);
export const AccountPaymentQrPage = lazy(() =>
  import('../../features/account/AccountPaymentQrPage.js').then((module) => ({
    default: module.AccountPaymentQrPage,
  }))
);
export const AccountAndPrivacyPage = lazy(() =>
  import('../../features/account/AccountAndPrivacyPage.js').then((module) => ({
    default: module.AccountAndPrivacyPage,
  }))
);
export const AccountPaymentClaimPage = lazy(() =>
  import('../../features/account/AccountPaymentClaimPage.js').then((module) => ({
    default: module.AccountPaymentClaimPage,
  }))
);
export const DurableConfirmationPage = lazy(() =>
  import('../../features/account/durable-confirmation/DurableConfirmationPage.js').then(
    (module) => ({
      default: module.DurableConfirmationPage,
    }),
  ),
);
export const AfterSaleIntakePage = lazy(() =>
  import('../../features/account/after-sale/AfterSaleIntakePage.js').then((module) => ({
    default: module.AfterSaleIntakePage,
  })),
);
export const AccountOrdersPage = lazy(() =>
  import('../../features/account/AccountOrdersPage.js').then((module) => ({
    default: module.AccountOrdersPage,
  }))
);
export const AccountShopTenantPage = lazy(() =>
  import('../../features/account/AccountShopTenantPage.js').then((module) => ({
    default: module.AccountShopTenantPage,
  }))
);
export const AccountShopKiosksPage = lazy(() =>
  import('../../features/account/AccountShopKiosksPage.js').then((module) => ({
    default: module.AccountShopKiosksPage,
  }))
);
export const CompleteVerificationPage = lazy(() =>
  import('../../features/account/CompleteVerificationPage.js').then((module) => ({
    default: module.CompleteVerificationPage,
  }))
);
export const AddPhonePage = lazy(() =>
  import('../../features/account/AddPhonePage.js').then((module) => ({
    default: module.AddPhonePage,
  }))
);
export const FindOrderPage = lazy(() =>
  import('../../features/orders/FindOrderPage.js').then((module) => ({
    default: module.FindOrderPage,
  }))
);
export const CardLinkRoute = lazy(() =>
  import('../../features/card-link/CardLinkRoute.js').then((module) => ({
    default: module.CardLinkRoute,
  }))
);
export const PickupVerifyPage = lazy(() =>
  import('../../features/pickup/PickupVerifyPage.js').then((module) => ({
    default: module.PickupVerifyPage,
  }))
);
export const TenantSelectScreen = lazy(() =>
  import('../../features/tenant-select/TenantSelectScreen.js').then((module) => ({
    default: module.TenantSelectScreen,
  }))
);
export const ShopsDirectoryScreen = lazy(() =>
  import('../../features/shops/ShopsDirectoryScreen.js').then((module) => ({
    default: module.ShopsDirectoryScreen,
  }))
);
export const MoreRouteRedirect = lazy(() =>
  import('../../features/more/MoreRouteRedirect.js').then((module) => ({
    default: module.MoreRouteRedirect,
  }))
);
export const HelpPage = lazy(() =>
  import('../../features/help/HelpPage.js').then((module) => ({
    default: module.HelpPage,
  }))
);
export const GuestReceiptOpenPage = lazy(() =>
  import('../../features/receipt/GuestReceiptOpenPage.js').then((module) => ({
    default: module.GuestReceiptOpenPage,
  }))
);
export const CustomerAppShell = lazy(() =>
  import('../CustomerAppShell.js').then((module) => ({
    default: module.CustomerAppShell,
  }))
);
